module.exports = __webpack_public_path__ + "static/media/footer-image1.75818754.png";